import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateSpecId'
})
export class TruncateSpecIdPipe implements PipeTransform {

  transform(value: string, ...args: any[]): any {
    const formattedSpecId = value.replace('Adamo_', '');
    return formattedSpecId.substring(0, formattedSpecId.lastIndexOf('_'));
  }

}
